module.exports = __webpack_public_path__ + "img/calc.e8a1b038.svg";